// Mirrors `Api::V1::TasksController::CARRY_OVER_STATUSES`. Keep the two in
// step: this is what decides whether the UI claims a task is carrying over,
// and that has to match the rule the backend actually applies when building
// the Today chip, or the indicator ends up pointing at tasks that aren't
// there (and missing ones that are).
export const CARRY_OVER_STATUSES = ['pending', 'started']

// True only while the flag is actually having an effect. `carry_over` stays
// set on a paused or finished task — the user's preference is still recorded,
// and the detail page's toggle still shows it — but the row/card indicator
// means "this keeps coming back to Today", which stops being true the moment
// the task is paused, completed or cancelled. Badging a completed card with
// "Carry over" would be stating something the app is no longer doing.
export function carriesOver(task) {
  return Boolean(task?.carry_over) && CARRY_OVER_STATUSES.includes(task.status)
}
